/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useLabels } from '@/hooks/useLabels';
import { View, Text } from '@az/starc-ui';

const labelMap = {
  lblNotes: 'label_CategoryPage_body_Notes',
};

type TechNotesProps = {
  techNotes: string;
};

const PdpTechNotesV2 = (props: TechNotesProps) => {
  const labels = useLabels(labelMap);
  return (
    <View direction="column">
      <View.Item>
        <Text variant="small-body" weight="bold">
          {labels.lblNotes}:
        </Text>
      </View.Item>
      <View.Item gapBefore={1}>
        <Text variant="small-body">{props.techNotes}</Text>
      </View.Item>
    </View>
  );
};

export default PdpTechNotesV2;
